module.exports = global["$"] = require("-!/codebuild/output/src2632655801/src/assets/node_modules/expose-loader/index.js?jQuery!./jquery.js");